import React from 'react';
import { Container, Card, ListGroup } from 'react-bootstrap';

const Donate = () => {
  return (
    <section id="donate" className="py-5" style={{ backgroundColor: '#f4f7f9' }}>
      <Container>
        <h2 className="text-center mb-4" style={{ color: '#0a4a7d', fontFamily: 'Montserrat, sans-serif', fontWeight: '700' }}>Donate Now</h2>
        <Card className="mx-auto" style={{ maxWidth: '600px', border: 'none', boxShadow: '0 4px 8px rgba(0,0,0,0.05)' }}>
          <Card.Header as="h3" className="text-center" style={{ backgroundColor: '#0a4a7d', color: 'white', fontFamily: 'Montserrat, sans-serif' }}>Bank Details</Card.Header>
          <ListGroup variant="flush" style={{ fontFamily: 'Roboto, sans-serif' }}>
            <ListGroup.Item><strong>Bank:</strong> Axis Bank</ListGroup.Item>
            <ListGroup.Item><strong>A/C No:</strong> 922020047094540</ListGroup.Item>
            <ListGroup.Item><strong>IFSC Code:</strong> UTIB0000070</ListGroup.Item>
            <ListGroup.Item><strong>SWIFT Code:</strong> AXISINBB070</ListGroup.Item>
          </ListGroup>
        </Card>
      </Container>
    </section>
  );
};

export default Donate;